export const contractVariables = {
    // Campo: 'nome da variavel no arquivo'
    ['Nome do Empreendimento']: 'empreendimento_nome',
    ['Tipo de Pessoa do Empreendimento']: 'empreendimento_tipo_pessoa',
    ['Tipo de Documento do Empreendimento']: 'empreendimento_tipo_documento',
    ['Documento do Empreendimento']: 'empreendimento_documento',
    ['Endereço do Empreendimento']: 'empreendimento_endereco',
    ['Nome do Representante do Empreendimento']: 'empreendimento_representante_nome',
    ['Nacionalidade do Representante do Empreendimento']: 'empreendimento_representante_nacionalidade',
    ['Estado Civil do Representante do Empreendimento']: 'empreendimento_representante_estado_civil',
    ['Profissão do Representante do Empreendimento']: 'empreendimento_representante_profissao',
    ['RG do Representante do Empreendimento']: 'empreendimento_representante_rg',
    ['CPF do Representante do Empreendimento']: 'empreendimento_representante_cpf',
    ['Protocolo do Empreendimento na Prefeitura']: 'empreendimento_protocolo',
    ['Informação de Posse do Empreendimento']: 'empreendimento_informacao_posse',
    ['Nome do Cliente']: 'cliente_nome',
    ['Tipo de Pessoa do Cliente']: 'cliente_tipo_pessoa',
    ['Tipo de Documento do Cliente']: 'cliente_tipo_documento',
    ['Nome do Representante do Cliente']: 'cliente_representante_nome',
    ['Estado Civil do Representante do Cliente']: 'cliente_representante_estado_civil',
    ['RG do Representante do Cliente']: 'cliente_representante_rg',
    ['CPF do Representante do Cliente']: 'cliente_representante_cpf',
    ['Documento do Cliente']: 'cliente_documento',
    ['Endereço do Cliente']: 'cliente_endereco',
    ['Identificador da Unidade']: 'unidade_identificador',
    ['Área Total da Unidade']: 'unidade_area_total',
    ['Vagas de Garagem da Unidade']: 'unidade_vagas_garagem',
    ['Lados da Unidade']: 'unidade_lados',
    ['Nome do Projeto']: 'projeto_nome',
    ['Endereço do Projeto']: 'projeto_endereco',
    ['Valor da Unidade']: 'unidade_valor',
    ['Valor da Unidade por Extenso']: 'unidade_valor_extenso',
    ['Valor da Venda da Unidade']: 'unidade_valor_venda',
    ['Valor da Venda da Unidade por Extenso']: 'unidade_valor_venda_extenso',
    ['Cidade/Estado da Unidade']: 'unidade_cidade_estado',
    ['Forma de Pagamento da Venda']: 'venda_forma_pagamento',
    ['Cidade do contrato e data atual']: 'cidade_data_atual',
    ['Cidade e estado do projeto']: 'projeto_cidade_estado',
    ['Número de alvará de construção do empreendimento']: 'empreendimento_numero_alvara',
    ['Área do terreno do projeto']: 'projeto_area_terreno',
}